import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Loading from '../../Shared/Loading/Loading';
import TypeAnimation from 'react-type-animation';
const Tools = () => {
    const [tools, setTools] = useState([])
    const navigate = useNavigate()
    useEffect(() => {
        const url = `https://fierce-sands-20967.herokuapp.com/tools`;
        fetch(url, {
            method: 'GET'
        })
            .then(res => res.json())
            .then(data => {
                if (data?.length >= 6) {
                    const newTools = data.slice(0, 6);
                    setTools(newTools)
                }
                else {
                    setTools(data)
                }
            })

    }, [])


    const handlePurchase = (id) => {
        navigate(`/purchase/${id}`)
    }
    return (
        <div className='bg-gray-100 pb-12'>
            {/* <TypeAnimation className='text-center text-primary py-12 text-5xl font-bold banner_text'
                cursor={false}
                sequence={['Our Tools', 1000, '']}
                wrapper="h2"
            /> */}
            <h1 className='text-center text-primary py-12 text-5xl font-bold banner_text'>Our Tools</h1>
            <div className='container flex justify-center'>
                {
                    tools[0]?.img ? <div className='grid grid-cols-1 lg:grid-cols-3 md:grid-cols-2 gap-12 '>
                        {
                            tools.map(tool =>
                                <div data-aos="fade-up" className='text-black'>
                                    <div class="card w-80 min-h-96 bg-base-100 shadow-2xl m-3 p-2 border-1 border-gray-200 rounded-none ">
                                        <figure className=''>
                                            <img src={tool.img} className='h-28' alt="Shoes" />
                                        </figure>
                                        <div class="card-body">
                                            <h2 class="card-title text-3xl banner_text">
                                                {tool.name}

                                            </h2>
                                            <p className='text-lg'>Price: ${tool.price}</p>
                                            <div class="card-actions justify-start gap-2">
                                                <div class=" text-lg">Quantity: ${tool.quantity}</div>
                                                <div class=" text-lg">Minimun order: ${tool.order}</div>
                                            </div>
                                            <button onClick={() => handlePurchase(tool._id)} className='w-ful btn bg-primary hover:bg-primary  rounded-none border-none text-white my-3'>Book Now!</button>
                                        </div>
                                    </div>
                                </div>

                            )
                        }
                    </div> : <Loading />
                }
            </div>
        </div>
    );
};

export default Tools;